export const RESELLER_SCHEMA = {
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://everest.ind.br/pt#organization",
   "name": "Everest Refrigeração Indústria e Comércio",
   "url": "https://everest.ind.br/pt"
  },
  {
   "@type": "WebSite",
   "@id": "https://everest.ind.br/pt#website",
   "url": "https://everest.ind.br/pt",
   "name": "Everest | Purificadores e Máquinas de Gelo",
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "inLanguage": "pt-BR",
   "potentialAction": {
    "@type": "SearchAction",
    "target": "https://everest.ind.br/pt?s={search_term_string}",
    "query-input": "required name=search_term_string"
   }
  },
  {
   "@type": "WebPage",
   "@id": "https://everest.ind.br/pt/seja-revendedor#webpage",
   "url": "https://everest.ind.br/pt/seja-revendedor",
   "name": "Seja Revendedor Everest | Torne-se um Revendedor Autorizado",
   "description": "Saiba como se tornar um revendedor autorizado dos purificadores de água e máquinas de gelo Everest em todo o Brasil.",
   "inLanguage": "pt-BR",
   "isPartOf": {
    "@id": "https://everest.ind.br/pt#website"
   },
   "about": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "publisher": {
    "@id": "https://everest.ind.br/pt#organization"
   },
   "breadcrumb": {
    "@id": "https://everest.ind.br/pt/seja-revendedor#breadcrumb"
   },
   "mainEntity": {
    "@type": "Service",
    "name": "Programa de Revenda Everest",
    "description": "Programa para revendedores autorizados de purificadores de água e máquinas de gelo Everest.",
    "provider": {
     "@id": "https://everest.ind.br/pt#organization"
    },
    "areaServed": {
     "@type": "Country",
     "name": "Brasil"
    }
   },
   "potentialAction": {
    "@type": "RegisterAction",
    "name": "Tornar-se revendedor Everest",
    "target": "https://everest.ind.br/pt/seja-revendedor"
   }
  },
  {
   "@type": "BreadcrumbList",
   "@id": "https://everest.ind.br/pt/seja-revendedor#breadcrumb",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://everest.ind.br/pt"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Seja Revendedor",
     "item": "https://everest.ind.br/pt/seja-revendedor"
    }
   ]
  }
 ]
}
